// @router
import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/components/base/routerParrent.vue");
import surveyGroupSearch from "../views/surveyGroupSearch.vue";
import editSurveyGroup from "../views/editSurveyGroup.vue";
import surveyParvandehLimit from "../views/surveyParvandehLimit.vue";
import allSurveySearch from "../views/allSurveySearch.vue";
import mySurveySearch from "../views/mySurveySearch.vue";
import addSurvey from "../views/addSurvey.vue";
import editSurvey from "../views/editSurvey.vue";
import surveyBaseSearch from "../views/surveyBaseSearch.vue";
import womenInfluenceConfirm from "../views/womenInfluenceConfirm.vue";

export const surveyRoutes: RouteConfig[] = [
  {
    path: "/survey",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "add",
        name: "survey",
        component: addSurvey,
        meta: {
          label: "ایجاد نظر",
          requiresAuth: true,
        },
      },
      {
        path: "survey-group",
        name: "survey_group",
        meta: {
          label: "گروه نظردهی",
          requiresAuth: true,
        },
        redirect: "/survey/survey-group/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "survey_group",
            component: surveyGroupSearch,
            meta: {
              label: "لیست گروه نظردهی",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:code",
            name: "survey_group_edit",
            component: editSurveyGroup,
            meta: {
              label: "ویرایش گروه نظردهی",
              requiresAuth: true,
            },
          },
          {
            path: "parvandeh/limit/:code/:id/:termId",
            name: "survey_parvandeh_limit",
            component: surveyParvandehLimit,
            meta: {
              label: "اعمال محدودیت در پرونده‌های قابل مشاهده",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "all-survey",
        name: "all_survey",
        meta: {
          label: "نظرات",
          requiresAuth: true,
        },
        redirect: "/survey/all-survey/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "all_survey",
            meta: {
              label: "لیست نظرات",
              requiresAuth: true,
            },
            component: allSurveySearch,
          },
          {
            path: "view/:code",
            name: "view_survey",
            component: editSurvey,
            meta: {
              label: "مشاهده نظر",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-survey",
        name: "my_survey",
        meta: {
          label: "نظرات",
          requiresAuth: true,
        },
        redirect: "/survey/my-survey/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "my_survey",
            component: mySurveySearch,
            meta: {
              label: "لیست نظرات من",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:code",
            name: "edit_survey",
            component: editSurvey,
            meta: {
              label: "ویرایش نظر",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "survey-base",
        name: "survey_base",
        meta: {
          label: "نظردهی",
          requiresAuth: true,
        },
        redirect: "/survey/survey-base/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "my_survey",
            component: surveyBaseSearch,
            meta: {
              label: "لیست نظردهی بانوان تاثیرگذار",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "women-influence-confirm",
        name: "survey_women_influence_confirm",
        meta: {
          label: "نظردهی",
          requiresAuth: true,
        },
        redirect: "/survey/women-influence-confirm/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "survey_women_influence_confirm",
            component: womenInfluenceConfirm,
            meta: {
              label: "انتخاب بانوان تاثیرگذار",
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
